import { useMediaQuery, useTheme } from '@mui/material'
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack'
import { FC, PropsWithChildren } from 'react'
import { Notification } from '../../components/Notification/Notification'

export const SnackbarProvider: FC<PropsWithChildren> = ({ children }) => {
    const { breakpoints } = useTheme()
    const isMobile = useMediaQuery(breakpoints.down('sm'))

    return (
        <NotistackSnackbarProvider
            maxSnack={isMobile ? 1 : 3}
            Components={{
                push: Notification,
            }}>
            {children}
        </NotistackSnackbarProvider>
    )
}
